import { Avatar_01, Avatar_05, Avatar_08, Avatar_13, Avatar_16 } from "../../Routes/ImagePath";

const ActivitiesData = {
    ActivitiesList: [
    {
        "user": "Lesley Grauer",
        "avatar": Avatar_01,
        "activity": "added new task Hospital Administration",
        "timestamp": "4 mins ago"
    },
    {
        "user": "Jeffery Lalor",
        "avatar": Avatar_16,
        "activity": "added Loren Gatlin and Tarah Shropshire to project Patient appointment booking",
        "timestamp": "6 mins ago"
    },
    {
        "user": "Catherine Manseau",
        "avatar": Avatar_08,
        "activity": "completed task Appointment booking with payment gateway",
        "timestamp": "12 mins ago"
    },
    {
        "user": "Bernardo Galaviz",
        "avatar": Avatar_13,
        "activity": "changed the task name Doctor available module",
        "timestamp": "1 day ago"
    },
    {
        "user": "Mike Litorus",
        "avatar": Avatar_05,
        "activity": "added new task Patient and Doctor video conferencing",
        "timestamp": "2 days ago"
    },
    {
        "user": "Jeffery Lalor",
        "avatar": Avatar_16,
        "activity": "added Jeffrey Warden and Bernardo Galaviz to the task of Private chat module",
        "timestamp": "7 days ago"
    }
]
}

export default ActivitiesData;